import React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../../../theme';

export type PercentBarProps = {
  barColor?: string;
  animatesChanges?: boolean;
  fillPercent: number;
};

const useStyles = makeStyles(() => ({
  backgroundBar: {
    width: '100%',
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.gallery,
  },
  bar: {
    height: 6,
    borderRadius: 3,
  },
}));

const PercentBar = ({
  fillPercent,
  animatesChanges = false,
  barColor = colors.bright_turquoise,
}: PercentBarProps): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.backgroundBar}>
      <div
        data-testid="bar"
        className={classes.bar}
        style={{
          backgroundColor: barColor,
          width: `${fillPercent}%`,
          transition: animatesChanges ? 'width 0.3s ease' : 'none',
        }}
      />
    </div>
  );
};

export default PercentBar;
